import { createSelector } from 'reselect';
import { receivedServerData } from '../../components/Common/Data/DataFetcher.js';
import { getBusinessName } from '../Organization/OrganizationData.js';
import WebsiteConfigurationApi from './WebsiteConfigurationApi.js';
import { getFirstName } from '../Pro/ProData';

export const WEBSITE_CONFIGURATION_NAMESPACE = 'websiteConfiguration';

export const receivedWebsiteConfigurationData = (data) => (dispatch) =>
  dispatch(receivedServerData(data, WEBSITE_CONFIGURATION_NAMESPACE));

export const getWebsiteConfiguration = createSelector(
  (state) => state[WEBSITE_CONFIGURATION_NAMESPACE],
  (websiteConfiguration) => websiteConfiguration || {}
);

export const getDomainName = createSelector(
  getWebsiteConfiguration,
  (websiteConfiguration) => websiteConfiguration.website_url || ''
);

const getPossibleDomainName = createSelector(
  getWebsiteConfiguration,
  (websiteConfiguration) => websiteConfiguration.possible_domain_name || ''
);

export const getPossibleDomainNameWithoutTLD = createSelector(getPossibleDomainName, (domainName) =>
  getNameWithoutTLD(domainName)
);

export const getDomainNameWithoutTLD = createSelector(getDomainName, (domainName) => getNameWithoutTLD(domainName));

function getNameWithoutTLD(domainName) {
  return domainName.replace('.com', '');
}

export const getDomainFromCompanyName = createSelector(getBusinessName, (businessName) =>
  businessName.replace(/[^a-z0-9]/gi, '').toLowerCase()
);

export const getShowPhysicalAddress = createSelector(
  getWebsiteConfiguration,
  (websiteConfiguration) => websiteConfiguration.show_physical_address || false
);

export const getDomainStatus = createSelector(
  getWebsiteConfiguration,
  (websiteConfiguration) => websiteConfiguration.domain_status || ''
);

export const getNetlifyURL = createSelector(
  getWebsiteConfiguration,
  (websiteConfiguration) => websiteConfiguration.netlify_url || ''
);

export const getSiteIsLiveState = createSelector(
  getDomainStatus,
  getDomainName,
  (domainStatus, domainName) => (domainStatus === 'VALID' || domainStatus === '') && !!domainName
);

export const getDomainIsActiveState = createSelector(
  getDomainStatus,
  getNetlifyURL,
  (domainStatus, netlifyURL) =>
    (domainStatus === 'VALID' || domainStatus === 'PENDING' || domainStatus === '') && !!netlifyURL
);

export const getRedirectionURL = createSelector(
  getSiteIsLiveState,
  getDomainIsActiveState,
  getDomainName,
  getNetlifyURL,
  getFirstName,
  (siteIsLive, domainIsActive, domainName, netlifyURL, proFirstName) => {
    if (siteIsLive) {
      return `https://${domainName}/edit`;
    } else if (domainIsActive) {
      return `https://${netlifyURL}/edit`;
    } else if (!proFirstName) {
      return '/pro/website_onboarding/business_name';
    } else {
      return '/pro/website_onboarding/domain?apps_page_launch';
    }
  }
);

export const fetchWebsiteConfiguration = {
  fetchingApiFunc: WebsiteConfigurationApi.show,
  selector: getWebsiteConfiguration,
  paramsFromProps: () => [],
  dataNamespace: WEBSITE_CONFIGURATION_NAMESPACE,
};
